import {AbstractEngine} from './AbstractEngine';
import {BaseAnimation} from '../animations/BaseAnimation';

class WebAnimationEngine extends AbstractEngine {

    declare protected animation:BaseAnimation;
    private running:boolean=false;
    private runningAnimations:Animation[]=[];

    constructor(animation:BaseAnimation) {
        super(animation);
    }

    public static getClassName():string {
        return 'WebAnimationEngine';
    }

    private camelify(prop:string) {
        return prop.replace(/-([a-z])/g,(g)=>g[1].toUpperCase());
    }

    private getSteps(anim:any):any[] {
        var steps=[];
        var apro=this.camelify(anim.property);
        for (var [offset,val] of Object.entries(anim.steps)) {
            steps.push({[apro]:val,offset:parseFloat(offset)/100});
        }
        steps.sort((a,b)=>a.offset-b.offset);
        return steps;
    }

    private getOptions(anim:any) {
        var opts={
            easing: anim.easing,
            duration: anim.duration
        };
        return opts;
    }

    public seek(pos:number):BaseAnimation {
        var animations=this.animation.getAnimations();
        var animatedElement=this.animation.getAnimatedElement();

        for (var anim of animations) {
            var apro=this.camelify(anim.property);
            var steps=this.getSteps(anim);
            var opts=this.getOptions(anim);

            var ke=new KeyframeEffect(animatedElement[0], steps, opts);
            var ani=new Animation(ke);

            ani.currentTime=pos;
        }
        return this.animation;
    }

    public scrub(pos:number):BaseAnimation {
        throw 'Scrub not implemented for WebAnimationEngine';
    }

    public stop():BaseAnimation {
        for (let ani of this.runningAnimations) {
            ani.cancel();
        }
        return this.animation;
    }

    public play():BaseAnimation {
        this.animation.trigger('begin');
        var promises=[];
        var animations=this.animation.getAnimations();
        var animatedElement=this.animation.getAnimatedElement();

        for (var anim of animations) {
            var apro=this.camelify(anim.property);
            var steps=this.getSteps(anim);
            var opts=this.getOptions(anim);

            var promise=new Promise(
                (resolve,reject) => {
                    var last_step=steps[steps.length-1];
                    var last_value=last_step[apro];
                    animatedElement.css(anim.property,last_value);
                    let anis=[];
                    for (let idx=0;idx<animatedElement.length;idx++) {
                        if (typeof animatedElement[idx].animate=="undefined") continue;
                        anis.push(animatedElement[idx].animate(steps,opts));
                    }

                    if (anis.length==0) {
                        resolve(true);
                        return;
                    }

                    var step=()=>{
                        if (!this.running) return;
                        this.animation.trigger('update');
                        window.requestAnimationFrame(step);
                    };
                    this.running=true;
                    window.requestAnimationFrame(step);

                    for (let idx=0;idx<anis.length;idx++) {
                        anis[idx].onfinish=(value)=>{
                            for (let k=0;k<this.runningAnimations.length;k++) {
                                let ra=this.runningAnimations[k];
                                if (ra===anis[idx]) {
                                    this.runningAnimations.splice(k,1);
                                    break;
                                }
                            }
                            resolve(value);
                        }
                    }

                    this.runningAnimations.push(...anis);
                }
            );
            promises.push(promise);
        }
        Promise.all(promises).then(()=>{
            this.runningAnimations=[];
            this.running=false;
            this.animation.trigger('end');
        });
        return this.animation;
    }

    static {
        this.init();
}

}

export {};